import { render, staticRenderFns } from "./DeliveryTripsPage.vue?vue&type=template&id=662d7f2e&scoped=true"
import script from "./DeliveryTripsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryTripsPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTripsPage.vue?vue&type=style&index=0&id=662d7f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d7f2e",
  null
  
)

export default component.exports